import React, { useEffect, useRef } from 'react';

const vacancies = [
  {
    title: 'Логіст',
    count: 2,
    subtitle: 'У логістичну компанію шукаємо 2-х логістів для роботи в команді. Емоційно-витривалі чоловіки.',
    duties: [
      'Робота з перевізниками',
      'Супровід заявок',
      'Комунікація з клієнтами',
    ],
    requirements: [
      'Відповідальність',
      'Бажання працювати і розвиватись',
      'Досвід у логістиці буде плюсом, але не обов\'язковий',
    ],
    offer: [
      'Навчання та підтримку',
      'Стабільну роботу',
      'Зрозумілі задачі',
      'Оплату за результат + можливість росту',
    ],
    contact: {
      name: 'Горяча Альона Юріївна',
      phone: '+380966341617',
    },
  },
  {
    title: 'Перевізник',
    count: null,
    isDriver: true,
    subtitle: 'Розшукуємо власників вантажівок! Маємо постійні вантажі Україною та Європою.',
    duties: [
      'Перевезення вантажів по Україні та Європі',
      'Дотримання строків доставки',
      'Відповідальне ставлення до вантажу',
    ],
    requirements: [
      'Власна вантажівка',
      'Бажання працювати стабільно',
      'Відповідальність та пунктуальність',
    ],
    offer: [
      'Постійні вантажі без простоїв',
      'Логісти, які не дзвонять кожних 5 хвилин',
      'Чесні умови та своєчасну оплату',
      'Довгострокову співпрацю',
    ],
    reelUrl: 'https://www.instagram.com/reel/DUnl_vijKvN/',
    contact: {
      name: 'Горяча Альона Юріївна',
      phone: '+380966341617',
    },
  },
];

function Vacancies() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.vacancy-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      minHeight: '100vh',
      padding: '140px 24px 80px',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #0d1a0e 50%, #0a0a0f 100%)',
    }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <div style={{
            display: 'inline-block',
            padding: '6px 20px',
            borderRadius: 30,
            background: 'rgba(22,183,36,0.1)',
            border: '1px solid rgba(22,183,36,0.2)',
            color: '#4dc247',
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginBottom: 24,
          }}>
            Приєднуйся до команди
          </div>
          <h1 style={{
            fontSize: 'clamp(28px, 5vw, 48px)',
            fontWeight: 700,
            color: '#fff',
            marginBottom: 16,
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
          }}>
            <span style={{
              background: 'linear-gradient(135deg, #16b724, #4dc247)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>Вакансії</span>
          </h1>
          <p style={{
            color: 'rgba(255,255,255,0.5)',
            fontSize: 16,
            maxWidth: 500,
            margin: '0 auto',
            lineHeight: 1.6,
          }}>
            Ми завжди шукаємо талановитих людей, які хочуть рости разом з нами
          </p>
        </div>

        {/* Vacancy Cards */}
        {vacancies.map((vacancy, i) => (
          <div key={i} className="vacancy-card" style={{
            opacity: 0,
            transform: 'translateY(40px)',
            transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
            borderRadius: 24,
            overflow: 'hidden',
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.06)',
            marginBottom: 32,
          }}>
            {/* Card Header */}
            <div style={{
              padding: '32px 40px',
              background: 'linear-gradient(135deg, rgba(22,183,36,0.08) 0%, transparent 100%)',
              borderBottom: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 16,
            }}>
              <div>
                <h2 style={{
                  fontSize: 28,
                  fontWeight: 700,
                  color: '#fff',
                  margin: 0,
                  marginBottom: 4,
                }}>
                  {vacancy.isDriver ? 'Розшукуємо перевізників!' : `Шукаємо ${vacancy.title.toLowerCase()}а`}
                </h2>
                {vacancy.count && (
                  <span style={{
                    color: 'rgba(255,255,255,0.5)',
                    fontSize: 14,
                  }}>
                    {vacancy.count} вакансії
                  </span>
                )}
              </div>
              <div style={{
                padding: '8px 20px',
                borderRadius: 30,
                background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                color: '#fff',
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
              }}>
                Активна
              </div>
            </div>

            {/* Card Body */}
            <div style={{ padding: '32px 40px' }}>
              <p style={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: 16,
                lineHeight: 1.7,
                marginBottom: 32,
                fontStyle: 'italic',
                borderLeft: '3px solid #4dc247',
                paddingLeft: 20,
              }}>
                {vacancy.subtitle}
              </p>

              {/* Sections Grid */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: 28,
                marginBottom: 32,
              }}>
                {/* Duties */}
                <div>
                  <h3 style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#4dc247',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: 16,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                  }}>
                    <span style={{ fontSize: 18 }}>&#9776;</span> Обов'язки
                  </h3>
                  {vacancy.duties.map((item, j) => (
                    <div key={j} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 10,
                      marginBottom: 10,
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}>
                      <span style={{ color: '#4dc247', fontSize: 8, marginTop: 6, flexShrink: 0 }}>&#9679;</span>
                      {item}
                    </div>
                  ))}
                </div>

                {/* Requirements */}
                <div>
                  <h3 style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#4dc247',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: 16,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                  }}>
                    <span style={{ fontSize: 18 }}>&#10003;</span> Вимоги
                  </h3>
                  {vacancy.requirements.map((item, j) => (
                    <div key={j} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 10,
                      marginBottom: 10,
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}>
                      <span style={{ color: '#4dc247', fontSize: 8, marginTop: 6, flexShrink: 0 }}>&#9679;</span>
                      {item}
                    </div>
                  ))}
                </div>

                {/* We Offer */}
                <div>
                  <h3 style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#4dc247',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: 16,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                  }}>
                    <span style={{ fontSize: 18 }}>&#9733;</span> Ми пропонуємо
                  </h3>
                  {vacancy.offer.map((item, j) => (
                    <div key={j} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 10,
                      marginBottom: 10,
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}>
                      <span style={{ color: '#4dc247', fontSize: 8, marginTop: 6, flexShrink: 0 }}>&#9679;</span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Instagram Reel Button */}
              {vacancy.reelUrl && (
                <div style={{
                  marginBottom: 32,
                  textAlign: 'center',
                }}>
                  <a
                    href={vacancy.reelUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 12,
                      padding: '16px 36px',
                      background: 'linear-gradient(135deg, rgba(22,183,36,0.15), rgba(22,183,36,0.05))',
                      border: '1px solid rgba(22,183,36,0.3)',
                      borderRadius: 50,
                      color: '#4dc247',
                      fontSize: 15,
                      fontWeight: 600,
                      textDecoration: 'none',
                      letterSpacing: '0.03em',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseOver={e => {
                      e.currentTarget.style.background = 'linear-gradient(135deg, #16b724, #0e8a1a)';
                      e.currentTarget.style.color = '#fff';
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 30px rgba(22, 183, 36, 0.4)';
                    }}
                    onMouseOut={e => {
                      e.currentTarget.style.background = 'linear-gradient(135deg, rgba(22,183,36,0.15), rgba(22,183,36,0.05))';
                      e.currentTarget.style.color = '#4dc247';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <span style={{ fontSize: 22 }}>&#9654;</span>
                    Переглянути відео
                  </a>
                </div>
              )}

              {/* Contact / CTA */}
              <div style={{
                padding: '24px 32px',
                borderRadius: 16,
                background: 'rgba(22,183,36,0.06)',
                border: '1px solid rgba(22,183,36,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 16,
              }}>
                <div>
                  <div style={{
                    color: 'rgba(255,255,255,0.5)',
                    fontSize: 13,
                    marginBottom: 4,
                  }}>
                    Контактна особа
                  </div>
                  <div style={{
                    color: '#fff',
                    fontSize: 16,
                    fontWeight: 600,
                  }}>
                    {vacancy.contact.name}
                  </div>
                </div>
                <a
                  href={`tel:${vacancy.contact.phone}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '14px 32px',
                    background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
                    color: '#fff',
                    fontSize: 15,
                    fontWeight: 600,
                    textDecoration: 'none',
                    borderRadius: 50,
                    letterSpacing: '0.03em',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 20px rgba(22, 183, 36, 0.3)',
                    whiteSpace: 'nowrap',
                  }}
                  onMouseOver={e => {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(22, 183, 36, 0.5)';
                  }}
                  onMouseOut={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(22, 183, 36, 0.3)';
                  }}
                >
                  <span style={{ fontSize: 18 }}>&#128222;</span>
                  +38 (096) 634 16 17
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Vacancies;
